import { memo, useCallback, useEffect, useMemo } from 'react'
import { Box, Divider, Flex, SimpleGrid, Text } from '@chakra-ui/react'

import { useCalendarFilters } from '../../contexts/CalendarFiltersManager/Provider'
import getPossibleDateIntervals from '../../contants/getPossibleDateIntervalFunctions'
import { callbackOnPressKey } from 'utils/events'

function DateIntervalShortcut() {
  const {
    dateFilterType,
    startHour,
    startDate,
    setStartDate,
    finalDate,
    finalHour,
    setFinalDate,
    setStartHour,
    setFinalHour,
    selectedDateInterval,
    setSelectedDateInterval,
  } = useCalendarFilters()

  const possibleDateIntervals: any = useMemo(() => {
    return getPossibleDateIntervals()
  }, [])

  const handleOnSelectShortcut = useCallback((params: any) => {
    setStartDate(params.startDate)
    setFinalDate(params.finalDate)
    setStartHour(params.startHour)
    setFinalHour(params.finalHour)
    setSelectedDateInterval(params)
  }, [])

  const isSomeDateIntervalSelected = (params: any) => {
    if (startDate !== params.startDate) return false
    if (finalDate !== params.finalDate) return false
    if (startHour !== params.startHour) return false
    if (finalHour !== params.finalHour) return false
    return true
  }

  const checkIfSomeDateIntervalSelected = () => {
    if (selectedDateInterval?.startDate !== startDate) return false
    if (selectedDateInterval?.finalDate !== finalDate) return false
    if (selectedDateInterval?.startHour !== startHour) return false
    if (selectedDateInterval?.finalHour !== finalHour) return false
    return true
  }

  useEffect(() => {
    const isSomeIntervalSelected = checkIfSomeDateIntervalSelected()

    if (!isSomeIntervalSelected) {
      setSelectedDateInterval(() => {
        return {
          label: '',
          name: '',
        }
      })
    }
  }, [startDate, finalDate, startHour, finalHour])

  if (dateFilterType === '') return null

  return (
    <>
      <Box width="100%" my={2}>
        <Divider borderColor="borderColor" />
      </Box>

      <Flex width="100%" direction="column" gap={2}>
        <Text color="primary" textAlign="center">
          Selecione um valor pré definido para a data
        </Text>
        <SimpleGrid width="100%" columns={[3, 3, 4, 5]} spacing={1}>
          {Object.entries(possibleDateIntervals).map(([key, getInterval]: any) => {
            const items = getInterval()

            const isSelected = isSomeDateIntervalSelected(items)

            return (
              <Box
                key={key}
                tabIndex={0}
                className="accessible"
                p={2}
                rounded="sm"
                textAlign="center"
                bg={isSelected ? 'primary' : 'light'}
                color={isSelected ? 'light' : 'dark'}
                borderWidth="1px"
                borderColor="borderColor"
                _hover={{ borderColor: 'lightPrimary', bg: 'lightPrimary' }}
                onClick={() => handleOnSelectShortcut(items)}
                onKeyUp={(event) => callbackOnPressKey(event, () => handleOnSelectShortcut(items))}
              >
                <Text fontSize="md">{items.label}</Text>
              </Box>
            )
          })}
        </SimpleGrid>
      </Flex>
    </>
  )
}

export default memo(DateIntervalShortcut)
